const ABProcessTaskEmailCore = require("../../../core/process/tasks/ABProcessTaskEmailCore");
module.exports = class ABProcessTaskEmail extends ABProcessTaskEmailCore {};
